<div class="mb-4">
  <strong class="fs-3">Gestion des clients</strong>
</div>

<admin-search-client></admin-search-client>

<admin-client-list
  [clients]="clients"
  (creditOrder)="onCreditOrder()"
  (deleteCredit)="onDeleteCredit()"
></admin-client-list>
